<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-rectangles-mixed', fontSet: 'fad'}"
	[headerText]="T.ASSIGN_STUDENT_TO_STATION_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<form (submit)="submit()" class="fieldSet">
			<!--RUN-->
			<mat-form-field [@zoomInOnEnter] [@zoomOutOnLeave] color="accent">
				<mat-label>
					<mat-icon fontIcon="fa-repeat" fontSet="fad" inline />
					{{ T.LABEL_RUN | translate }}
				</mat-label>
				<mat-select [formControl]="form.controls.runId">
					@for (runId of store.runIds(); track runId) {
						<mat-option [value]="runId"> {{ T.LABEL_RUN | translate }} {{ $index + 1 }}</mat-option>
					}
				</mat-select>
				<mat-error>{{ T.ERROR_SELECTION_REQUIRED | translate }}</mat-error>
			</mat-form-field>

			<!--STUDENT-->
			<mat-form-field>
				<mat-label>
					<mat-icon fontIcon="fa-user" fontSet="fad" inline />
					{{ T.LABEL_STUDENT | translate }}
				</mat-label>
				<mat-select [formControl]="form.controls.student" class="studentSelect">
					<mat-select-trigger>
						@if (selectedStudent()) {
							<ng-container [ngTemplateOutlet]="studentItem" [ngTemplateOutletContext]="{$implicit: selectedStudent()}" />
						}
					</mat-select-trigger>
					@for (student of studentsView(); track student.id) {
						<mat-option [value]="student">
							<ng-container [ngTemplateOutlet]="studentItem" [ngTemplateOutletContext]="{$implicit: student}" />
						</mat-option>
					}
				</mat-select>
				<mat-error>
					@if (form.controls.stationId.hasError("illegalAssignment")) {
						{{ T.ASSIGN_STUDENT_TO_STATION_DIALOG_ERROR_ILLEGAL_ASSIGNMENT | translate }}
					} @else {
						{{ T.ERROR_SELECTION_REQUIRED | translate }}
					}
				</mat-error>
			</mat-form-field>

			<!--STATION-->
			<mat-form-field>
				<mat-label>
					<mat-icon fontIcon="fa-rectangles-mixed" fontSet="fad" inline />
					{{ T.LABEL_STATION | translate }}
				</mat-label>
				<mat-select [formControl]="form.controls.stationId">
					<mat-select-trigger>
						@if (selectedStation()) {
							<ng-container [ngTemplateOutlet]="stationOption" [ngTemplateOutletContext]="{$implicit: selectedStation()}" />
						}
					</mat-select-trigger>
					@for (station of stations(); track station.id; let index = $index) {
						<mat-option [value]="station.id">
							<ng-container [ngTemplateOutlet]="stationOption" [ngTemplateOutletContext]="{$implicit: {station, index}}" />
						</mat-option>
					}
				</mat-select>
				<mat-error>
					@if (form.controls.stationId.hasError("illegalAssignment")) {
						{{ T.ASSIGN_STUDENT_TO_STATION_DIALOG_ERROR_ILLEGAL_ASSIGNMENT | translate }}
					} @else {
						{{ T.ERROR_SELECTION_REQUIRED | translate }}
					}
				</mat-error>
			</mat-form-field>
			<button #formSubmit hidden type="submit"></button>
		</form>
	</ng-container>
	<ng-container actions>
		<sim-autosave-widget [promise]="savePromise()" [timestamp]="null" />

		<sim-button
			(onClick)="formSubmit.click()"
			[disabled]="!hasChanged()"
			[hasPermission]="Permissions.Create_Exam_Session"
			[icon]="{fontIcon: 'fa-check', fontSet: 'fas'}"
			[label]="T.BUTTON_SAVE"
		/>
	</ng-container>
</sim-basic-material-dialog>

<!--TEMPLATES-->
<ng-template #studentItem let-student>
	<div class="optionContent">
		<div [style.background-color]="student.color" class="indicatorDot">
			{{ student.firstname | slice: 0 : 1 }}{{ student.lastname | slice: 0 : 1 }}
		</div>
		<div class="labelWrapper">
			<span #studentName class="studentName">
				{{ student.fullname }}
			</span>
			@let stationMapping = studentToStationMap().get(student.id);
			@if (stationMapping) {
				@if (stationMapping.index >= 0) {
					<span class="secondary"> {{ T.LABEL_STATION | translate }} {{ stationMapping.index + 1 }} </span>
				} @else {
					<span class="secondary"> {{ T.LABEL_WAITING_ROOM | translate }} </span>
				}
			}
		</div>
	</div>
</ng-template>

<ng-template #stationOption let-context>
	@let station = context.station;
	@let studentMapping = stationToStudentMap().get(station.id);
	<div class="optionContent">
		<div [style.background-color]="'#279989'" class="indicatorDot">{{ context.index + 1 }}</div>
		<div class="labelWrapper">
			<span>{{ station.trainingRoomName }} | {{ station.scenarioName }}</span>
			@if (studentMapping) {
				<span class="secondary">{{ studentMapping.fullname }}</span>
			}
		</div>
	</div>
</ng-template>
